import { AlertChunky } from '@eventbrite/eds-iconography';
import { NotificationBar } from '@eventbrite/eds-notification';
import React from 'react';
import { INotificationContextItem } from '../../../contexts/NotificationsContext';
import './AuthNotification.scss';
import AuthNotificationButton from './AuthNotificationButton';
import AuthNotificationExtra from './AuthNotificationExtra';

const AuthNotification = ({
    notificationMessage,
    handleOnClick,
}: {
    notificationMessage: INotificationContextItem;
    handleOnClick?: () => void;
}) => {
    let component = null;

    if (notificationMessage?.message || notificationMessage?.extraMessage) {
        const { message, extraMessage, ...props } = notificationMessage;

        let messageComponent = null;
        const extraMessageComponent = (
            <AuthNotificationExtra extraMessage={extraMessage} />
        );
        const buttonComponent = (
            <AuthNotificationButton
                notificationMessage={notificationMessage}
                handleOnClick={handleOnClick}
            />
        );

        if (message) {
            messageComponent = (
                <strong>
                    {message} {extraMessage && <br />}
                </strong>
            );
        }

        component = (
            <div className="auth-lib__notification-container eds-l-mar-bot-3 eds-fx--bounce eds-text-bm">
                <NotificationBar iconType={<AlertChunky />} {...props}>
                    {messageComponent} {extraMessageComponent} {buttonComponent}
                </NotificationBar>
            </div>
        );
    }

    return component;
};

export default AuthNotification;
